import {getIdToken} from "../../../misc/miscUtils.ts";
import {URL_BASE} from "../../../../Globals.ts";


export const writeSettings = async (user: any, settings: any, formattedEnvName: string) => {
    if (!user) return;

    try {
        const token = await getIdToken(user);
        const url = `${URL_BASE}/api/writeSettings`;

        await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                settings: settings,
                environment: formattedEnvName
            })
        });
    } catch (error) {
        console.error(`Error writing settings: ${error}`);
    }
};